import { wrapRequest } from '@applandeo/api-wrapper';
import { useEffect, useState } from 'react';

import { getUserPicture } from '@/dataExchange/services/user.service';
import { NewRequestWhere } from '@/domain/newRequest';
import { AbsenceWithTypeData } from '@/domain/requestsPage';
import { ProfilePictureType } from '@/domain/user';
import useAcceptDeletionLogic from '@/pages/Requests/common/DeletRequestButton/useAcceptDeletionLogic';

const useLeadRequestDetailsModalLogic = ({
    singleRequestDetails,
    where,
    onCloseModal,
    getRequests,
}: {
    singleRequestDetails: AbsenceWithTypeData;
    where?: NewRequestWhere;
    onCloseModal: () => void;
    getRequests: () => void;
}) => {
    const getUserPictureWrapper = wrapRequest(getUserPicture);

    const [isEditView, setIsEditView] = useState(false);
    const [userPicture, setUserPicture] = useState<ProfilePictureType>('');

    const { acceptDelete, rejectDelete, isActionLoading } = useAcceptDeletionLogic({
        absenceId: singleRequestDetails._id,
        where,
        absenceName: singleRequestDetails?.typeData?.name,
        onCloseModal,
        getRequests,
    });

    useEffect(() => {
        if (!singleRequestDetails.userDto?.profilePictureUrl) return;
        getUserPictureWrapper.fetch(singleRequestDetails.userDto?.profilePictureUrl).onSuccess(response => {
            if (!response) return;
            setUserPicture(response);
        });
    }, [singleRequestDetails.userDto?.profilePictureUrl]);

    return {
        isEditView,
        setIsEditView,
        userPicture,
        rejectDelete,
        acceptDelete,
        isActionLoading,
    };
};

export default useLeadRequestDetailsModalLogic;
